module.exports = __webpack_public_path__ + "static/logo-2022-f6f96ea3819a5140a6eadc1118ddfc1a.png";